var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './SixSDCC.scss';
import ProductPoster from '../KodanshaUIKit/ProductPoster/ProductPoster';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import { ProductsData } from '../AX/ProductsData';
import { scrollToItem } from '../../utils/utils';
import { useAtom } from 'jotai';
import { LoginStatusAtom } from '../../store/AccountStore';
import { LoginOverlayVisible } from '../../store/OverlayStore';
import { Link } from 'react-router-dom';
export var axSamplerButtonStatus;
(function (axSamplerButtonStatus) {
    axSamplerButtonStatus[axSamplerButtonStatus["claim"] = 0] = "claim";
    axSamplerButtonStatus[axSamplerButtonStatus["signuptoread"] = 1] = "signuptoread";
    axSamplerButtonStatus[axSamplerButtonStatus["read"] = 2] = "read";
})(axSamplerButtonStatus || (axSamplerButtonStatus = {}));
var MangaItem = function (_a) {
    var data = _a.data, id = _a.id, claimed = _a.claimed;
    var _b = __read(useAtom(LoginStatusAtom), 1), loginStatus = _b[0];
    var _c = __read(useAtom(LoginOverlayVisible), 2), setLoginOverlay = _c[1];
    var scrollToClaim = function (e) {
        scrollToItem('intro-ax', 120);
        return;
    };
    var logInSignup = function (e) {
        setLoginOverlay(true);
        return;
    };
    return _jsxs("div", { className: 'six-item-wrapper', children: [_jsx(ProductPoster, { src: 'https://cdn.kodansha.us/statics/Publications/' + (data === null || data === void 0 ? void 0 : data.reader) + '/Pages/page-0001.jpg', ratio: 140 }), _jsx("span", { className: 'sampler', children: "DISCOVER KODANSHA" }), _jsx("span", { className: 'name', children: data.sampler }), loginStatus === "LoggedIn" ?
                _jsx(Link, { to: '/reader/' + data.reader.toString(), children: _jsx(KodanshaUnderlinedText, { text: 'Read' }) })
                :
                    _jsx(KodanshaUnderlinedText, { onClick: logInSignup, text: "Sign up to read" })] });
};
var SixSDCC = function (props) {
    return (_jsxs("div", { className: 'six-ax-container', children: [_jsx("h1", { className: 'header-one', id: 'digital-manga-samplers-title', children: "DIGITAL MANGA SAMPLERS" }), _jsx("h2", { className: 'header-two', children: "Sample our best manga across six genres" }), _jsx("div", { className: 'six-ax-wrapper', children: ProductsData.map(function (data, index) { return _jsx(MangaItem, { data: data, id: index, claimed: props.redeemComics }); }) })] }));
};
export default SixSDCC;
